import React, { Component } from 'react';
import AuthService from '../services/auth.service';
import ApiService from '../services/api.service';
import Swal from 'sweetalert2';

// Debe reflejar apivegetales/lib/constants/whatsapp.js (WHATSAPP_PROVIDER) —
// son apps separadas, no hay import compartido entre back-end y apivegetales.
const WHATSAPP_PROVIDER = {
  FACTILIZA: 'FACTILIZA',
  CLOUD: 'CLOUD',
};

const EDITABLE_FLOWS = [
  {
    key: 'whatsapp_provider_recordatorio',
    label: 'Recordatorio de cobro',
    description: 'Link de pago para deudas pendientes (individual y cobro masivo).',
    reason: 'Plantilla recordatorio_pago_pendiente aprobada — lista para migrar a Cloud API (Meta).',
  },
  {
    key: 'whatsapp_provider_pago_recibido',
    label: 'Pago recibido',
    description: 'Se envía cuando se registra un pago/voucher.',
    reason: 'Plantilla pago_recibido_confirmacion aprobada — lista para migrar a Cloud API (Meta).',
  },
  {
    key: 'whatsapp_provider_pedido',
    label: 'Pedido confirmado',
    description: 'Se envía cuando el cliente hace un nuevo pedido.',
    reason: 'Plantilla pedido_confirmado aprobada — lista para migrar a Cloud API (Meta).',
  },
  {
    key: 'whatsapp_provider_solicitud',
    label: 'Dirección registrada / Perfil actualizado',
    description: 'Se envía cuando el cliente agrega una dirección o actualiza su perfil (mismo mensaje para ambos).',
    reason: 'Plantilla solicitud_registrada aprobada — lista para migrar a Cloud API (Meta).',
  },
  {
    key: 'whatsapp_provider_recordatorio_seguridad',
    label: 'Recordatorio semanal (vaciar chats)',
    description: 'Mensaje semanal al cliente pidiendo vaciar los chats de WhatsApp.',
    reason: 'Plantilla recordatorio_seguridad_chats enviada — en revisión de Meta.',
  },
  {
    key: 'whatsapp_provider_pedido_operaciones',
    label: 'Resumen de pedidos (operaciones)',
    description: 'Aviso al número de operaciones con el conteo de pedidos del día.',
    reason: 'Plantilla resumen_pedidos_operaciones enviada — en revisión de Meta.',
  },
  {
    key: 'whatsapp_provider_pedido_telefono',
    label: 'Pago recibido (teléfono general)',
    description: 'Aviso al número general del negocio cuando se registra un pago diferido.',
    reason: 'Plantilla aviso_pago_recibido_admin enviada — en revisión de Meta.',
  },
  {
    key: 'whatsapp_provider_pago_pendiente_admin',
    label: 'Pago pendiente de verificación (admin)',
    description: 'Aviso al número principal cuando un pago queda pendiente de verificar.',
    reason: 'Plantilla aviso_pago_pendiente_verificacion enviada — en revisión de Meta.',
  },
  {
    key: 'whatsapp_provider_direccion_admin',
    label: 'Nueva dirección (admin)',
    description: 'Aviso al número principal cuando un cliente registra una nueva dirección.',
    reason: 'Plantilla aviso_direccion_nueva enviada — en revisión de Meta.',
  },
];

const LOCKED_FLOWS = [
  {
    label: 'OTP / código de seguridad',
    description: 'Código de verificación al iniciar sesión.',
    reason: 'Requiere categoría AUTHENTICATION en Meta, que exige verificación de negocio (pendiente).',
  },
  {
    label: 'Campañas de marketing',
    description: 'Envíos masivos armados por el admin desde el panel.',
    reason: 'El texto es libre por campaña — Cloud API solo permite plantillas fijas pre-aprobadas.',
  },
];

const defaultProviders = () =>
  EDITABLE_FLOWS.reduce((acc, flow) => {
    acc[flow.key] = WHATSAPP_PROVIDER.FACTILIZA;
    return acc;
  }, {});

export class WhatsappProviderSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      providers: defaultProviders(),
      loading: false,
      saving: false,
    };
    this.handleSave = this.handleSave.bind(this);
  }

  componentDidMount() {
    this.loadSettings();
  }

  loadSettings() {
    const user = AuthService.getCurrentUser();
    this.setState({ loading: true });

    ApiService.getSettings(user.token).then((res) => {
      this.setState({ loading: false });

      if (res && res.status === 'success') {
        const providers = defaultProviders();
        EDITABLE_FLOWS.forEach((flow) => {
          const found = res.data.find((item) => item.option_name === flow.key);
          if (found) {
            providers[flow.key] = found.option_value;
          }
        });
        this.setState({ providers });
      }
    });
  }

  handleSave(e) {
    e.preventDefault();

    const user = AuthService.getCurrentUser();
    const data = EDITABLE_FLOWS.map((flow) => ({
      name: flow.key,
      value: this.state.providers[flow.key],
    }));

    this.setState({ saving: true });

    ApiService.updateSettings(user.token, { data }).then(
      (res) => {
        this.setState({ saving: false });
        if (res && res.status === 'success') {
          Swal.fire('Hecho!', 'Configuración de proveedor guardada.', 'success');
        } else {
          Swal.fire('Error', (res && res.message) || 'No se pudo guardar la configuración.', 'error');
        }
      },
      () => {
        this.setState({ saving: false });
        Swal.fire('Error', 'No se pudo guardar la configuración.', 'error');
      }
    );
  }

  setProvider(key, value) {
    this.setState({ providers: { ...this.state.providers, [key]: value } });
  }

  render() {
    return (
      <div className="card">
        <div className="card-header">
          <h5>Proveedor de envío por tipo de mensaje</h5>
          <span className="f-light">
            Elegí el proveedor de envío por tipo de mensaje. Los que ya tienen plantilla aprobada en Meta
            funcionan con Cloud API; los demás quedan configurados pero siguen por Factiliza hasta que Meta
            apruebe su plantilla.
          </span>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Mensaje</th>
                  <th>Factiliza</th>
                  <th>Cloud API</th>
                  <th>Motivo</th>
                </tr>
              </thead>
              <tbody>
                {EDITABLE_FLOWS.map((flow) => (
                  <tr key={flow.key}>
                    <td>
                      <strong>{flow.label}</strong>
                      <div className="f-light f-12">{flow.description}</div>
                    </td>
                    <td>
                      <label className="d-block mb-0">
                        <input
                          className="radio_animated"
                          type="radio"
                          name={flow.key}
                          checked={this.state.providers[flow.key] === WHATSAPP_PROVIDER.FACTILIZA}
                          onChange={() => this.setProvider(flow.key, WHATSAPP_PROVIDER.FACTILIZA)}
                        />
                      </label>
                    </td>
                    <td>
                      <label className="d-block mb-0">
                        <input
                          className="radio_animated"
                          type="radio"
                          name={flow.key}
                          checked={this.state.providers[flow.key] === WHATSAPP_PROVIDER.CLOUD}
                          onChange={() => this.setProvider(flow.key, WHATSAPP_PROVIDER.CLOUD)}
                        />
                      </label>
                    </td>
                    <td className="f-light">{flow.reason}</td>
                  </tr>
                ))}
                {LOCKED_FLOWS.map((flow) => (
                  <tr key={flow.label}>
                    <td>
                      <strong>{flow.label}</strong>
                      <div className="f-light f-12">{flow.description}</div>
                    </td>
                    <td>
                      <input className="radio_animated" type="radio" checked readOnly />
                    </td>
                    <td>
                      <input className="radio_animated" type="radio" disabled />
                    </td>
                    <td className="f-light">{flow.reason}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="card-body d-flex justify-content-end border-top">
          <button className="btn btn-primary" disabled={this.state.saving} onClick={this.handleSave}>
            {this.state.saving && <span className="spinner-border spinner-border-sm mr-2"></span>}
            <span>Guardar</span>
          </button>
        </div>
      </div>
    );
  }
}

export default WhatsappProviderSettings;
